import { onError } from '@apollo/client/link/error';

/**
 * Error handling function for apollo client
 */
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path, extensions }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(
          locations
        )}, Path: ${path}\nextensions: ${JSON.stringify(
          extensions,
          null,
          '  '
        )}`
      )
    );
  }
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

export default errorLink;
